<nav class="flex" aria-label="Breadcrumb">
  <div class="no-scrollbar flex max-w-full overflow-x-auto direction-rtl">
    <ol
      class="flex items-center gap-2xs whitespace-nowrap direction-ltr"
      itemscope
      itemtype="https://schema.org/BreadcrumbList"
    >
      @if (showBackButton) {
        <li class="back-button">
          @if (previousBreadcrumb.link) {
            <cft-back-button [light]="light" [path]="previousBreadcrumb.link"></cft-back-button>
          }
        </li>
      }
      @for (breadcrumb of previousBreadcrumbs; track i; let i = $index) {
        <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
          <a
            cft-breadcrumb
            [light]="light"
            [routerLink]="breadcrumb.link"
            [class.cursor-pointer]="breadcrumb.navigateFn"
            itemscope
            itemtype="https://schema.org/WebPage"
            itemprop="item"
            [attr.itemid]="breadcrumb.link"
            (click)="navigate(breadcrumb)"
          >
            <span itemprop="name">
              {{ breadcrumb.name }}
            </span>
          </a>
          <meta itemprop="position" [content]="i + 1" />
        </li>
      }
      <li
        aria-current="page"
        class="cursor-default font-semibold"
        itemprop="itemListElement"
        itemscope
        itemtype="https://schema.org/ListItem"
      >
        <span cft-breadcrumb [light]="light" [active]="true" [showSeparator]="false" itemprop="name">
          {{ currentBreadcrumb.name }}
        </span>
        <meta itemprop="position" [content]="previousBreadcrumbs.length + 1" />
      </li>
    </ol>
  </div>
</nav>
